import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "./styles/Global.css";

function App() {
  return (
    <div className="App" style={styles.app}>
      <AppRoutes />
    </div>
  );
}

const styles = {
  app:{
    display:"flex",    
    justifyContent:"center"
  }
}

export default App;